const Training = {
  init() {
    Training.events();
    Training.fixLineWidth();
  },

  events() {
    $(".btn-training-type").on("click", (e) =>
      Training.handleTrainingType(e.currentTarget)
    );
  },

  fixLineWidth() {
    const btnWidth = this.getButtonWidth($(".btn-training-type.active"));
    const line = $(".training-types .line");

    line.css({ width: `${btnWidth}px` });
  },

  handleTrainingType(clickedButton) {
    const btn = $(clickedButton);

    if (btn.hasClass("active")) {
      return;
    }

    btn.addClass("active").siblings().removeClass("active");
    Training.handleDrawLine(clickedButton);
  },

  handleDrawLine(clickedButton) {
    const btn = $(clickedButton);
    const line = $(".training-types .line");
    const btnWidth = Training.getButtonWidth(clickedButton);
    const firstBtnWidth = Training.getButtonWidth(
      ".btn-training-type--forwarder"
    );
    const containerWidth = $(".training-types").innerWidth();

    line.css({ width: `${btnWidth}px` });

    if (btn.hasClass("btn-training-type--harvester")) {
      line.css({ transform: `translateX(${firstBtnWidth + 56}px)` });
      $(".training-forwarder").addClass("hidden");
      $(".training-other").addClass("hidden");
      $(".training-harvester").removeClass("hidden");
    } else if (btn.hasClass("btn-training-type--other")) {
      line.css({ transform: `translateX(${containerWidth - btnWidth}px)` });
      $(".training-forwarder").addClass("hidden");
      $(".training-other").removeClass("hidden");
      $(".training-harvester").addClass("hidden");
    } else {
      line.css({ transform: "translateX(0px)" });
      $(".training-forwarder").removeClass("hidden");
      $(".training-other").addClass("hidden");
      $(".training-harvester").addClass("hidden");
    }
  },

  getButtonWidth(btn) {
    return $(btn).innerWidth();
  },
};

export default Training;
